import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import './App.css';

// Every route but the home page is loaded on demand. The legal text and
// framer-motion (which only the legal pages animate with) were 44 % of the
// script a visitor to / downloaded and compiled; firstPaintBundle.test.js
// keeps them out. framer-motion's reduced-motion setting (MotionConfig) now
// lives in the pages that use it.
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage'));
const ChangelogPage = lazy(() => import('./pages/ChangelogPage'));
const SubprocessorsPage = lazy(() => import('./pages/SubprocessorsPage'));

// Light and dark follow the system (prefers-color-scheme, tokens in
// index.css).
//
// /j/<code> (a crew invite) is NOT a route here: it is a static page,
// public/j/index.html, served by public/_redirects. See that file.
function App() {
  return (
    <Router>
      <ScrollToTop />
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <div className="App">
        <Navbar />
        <main id="main">
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              {/* The privacy policy links here rather than naming vendors inline. */}
              <Route path="/subprocessors" element={<SubprocessorsPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
